export enum GameObjectEvent {
    DESTROYED = 'destroyed',
    CHILD_ADDED = 'childAdded',
    CHILD_REMOVED = 'childRemoved',
    POINTER_DOWN = 'pointerDown',
    POINTER_OUT = 'pointerOut',
    POINTER_OVER = 'pointerOver',
    POINTER_UP = 'pointerUp',
    SELECTED = 'selected',
}
